import React from 'react';

import { TouchableOpacity } from 'components/primitives/cross-platform';
import { PLATFORM_ASSETS_URL } from 'config/envVars/assets';
import Image from 'cross-platform/Image';
import { roles } from 'cross-platform/utils/roleProps';
import { openURL } from 'lib/navigation/openURL';

export const AppStoreButton = ({
  height,
  width,
  url,
}: {
  height: number;
  width: number;
  url: string;
}): React.ReactElement => {
  const urlImage = `${PLATFORM_ASSETS_URL}assets/app-store-image.png`;
  return (
    <TouchableOpacity
      {...roles('AppStoreButton')}
      onPress={() => {
        openURL(url);
      }}
    >
      <Image src={urlImage} style={{ height: height, width: width }} />
    </TouchableOpacity>
  );
};
